<template>
    <div class="exception-404">
        <a-result class="exception-40" status="404" title="404" :sub-title="$t('message.notfound')">
            <template #extra>
                <a-button type="primary" @click="toHome">
                    {{ $t('message.backHome') }}
                </a-button>
            </template>
        </a-result>
    </div>
</template>

<script>
export default {
    name: 'Exception404Page',
    methods: {
        toHome() {
            this.$router.push({ path: '/' });
        }
    }
};
</script>
<style lang="less" scoped>
.exception-404 {
    height: calc(100vh);
    margin: 40px;
    background-color: #FFF;
    border-radius: 20px;
    .exception-40{
        padding-top: 100px;
    }
}
</style>
